import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react'
import NoDataMsg from '../common/components/NoDataMsg';
import AuthContext from '../contexts/authContext';
import useSortableData from '../hooks/useSortableData';
import Page from '../layout/Page/Page';
import PageWrapper from '../layout/PageWrapper/PageWrapper';
import { showLoader, TableLoader } from '../services/loader.services';
import { addSubInvoice, getInvoiceDetails, getProductDetailsCount, updateInvoiceDetails, updateSubInvoiceDetails } from '../services/productService';
import { toasts } from '../services/toaste.service';
import Button, { ButtonGroup } from './bootstrap/Button';
import Card, { CardHeader, CardLabel, CardTitle, CardBody, CardActions } from './bootstrap/Card';
import Icon from './icon/Icon';
import PaginationButtons, { dataPagination } from './PaginationButtons';
import Input from './bootstrap/forms/Input';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from './bootstrap/Modal';
import FormGroup from './bootstrap/forms/FormGroup';
import SearchableSelect from '../common/components/SearchableSelect';
import { getCompanyDetails, getCurrentDateAndTime, getHsnCode, onlyAllowNumber } from '../services/common.service';
import InputGroup, { InputGroupText } from './bootstrap/forms/InputGroup';
import { getLicenseKey } from '../services/application.settings';
import AlertService from '../services/alert.service';

const InvoiceList = () => {

    useEffect(() => {
        getInvoice()
        getCompanyList()
        getHsnCodeList()
    }, [])

    const columnVisibileForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
            available: false,
        },
        validate: (values) => { },
        //validateOnChange: false,
        onSubmit: () => { },
    });

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const [invoiceData, setInvoiceData] = useState<any>([])
    const [noDataMsg, setNoDataMsg] = useState('')

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const { items, requestSort, getClassNamesFor } = useSortableData(invoiceData);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    const [dataStatus, setDataStatus] = useState(false)

    // Filter
    const filteredData: any = onCurrentPageData.filter(
        (i) =>
            (i.sno && i.sno.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.invoiceNo && i.invoiceNo.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.invoiceDate && i.invoiceDate.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.transportMode && i.transportMode.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.truckNo && i.truckNo.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())) ||
            (i.companyName && i.companyName.toString().toLowerCase().includes(columnVisibileForm.values.searchInput.toLowerCase())),
    );

    function getInvoice() {
        getInvoiceDetails(
            (response) => {
                if (response.data.success) {
                    let rawData = response.data.data.invoiceDetails;
                    if (rawData != undefined) {
                        setDataStatus(true)
                        let mappedData = rawData.map((item: any, index: number) => ({
                            ...item,
                            sno: index + 1,
                            invoiceId: item.invoiceUniqueNo,
                            truckNo: item.vehicleNo,
                            productDetails: (item.invoiceItems || []).map((p: any) => ({
                                ...p,
                                finalAmount: p.invoiceAmount,
                                amountDetails: [{
                                    ...p,
                                    finalAmount: p.invoiceAmount
                                }]
                            }))
                        }));
                        setInvoiceData(mappedData)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setNoDataMsg(response.data.message)
                    setDataStatus(true)
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function onPrint(i: any) {
        if (i != undefined) {
            let selectedData = i
            window.open(selectedData.pdfPath);
        }
    }

    // For Alert
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isOpen, setIsOpen] = useState<any>(false);

    const [companyDetailsData, setCompanyDetailsData] = useState<any>([]);

    function getCompanyList() {
        getCompanyDetails(0,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.companyDetails;
                    if (data != undefined) {
                        setCompanyDetailsData(data)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setCompanyDetailsData([])
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    const [hsnCodeData, setHsnCodeData] = useState<any>([]);

    function getHsnCodeList() {
        getHsnCode(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.hsnCode;
                    if (data != undefined) {
                        setHsnCodeData(data)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setHsnCodeData([])
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    const [invoiceFromData, setInvoiceFromData] = useState<any>([
        { companyDetailsId: 1, companyName: 'ACV PRODUCTS PRIVATE LIMITED' },
        { companyDetailsId: 2, companyName: 'AVR TERRY TEX' }
    ])

    const [invoiceFromId, setInvoiceFromId] = useState<any>('');

    const [isOpenModal, setIsOpenModal] = useState<any>(false)
    const [invoiceDetailsData, setInvoiceDetailsData] = useState<any>([])
    const [companyDetailsId, setCompanyDetailsId] = useState<any>('ACV PRODUCTS PRIVATE LIMITED')

    const invoiceForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            invoiceDate: getCurrentDateAndTime('date'),
            billOfParty: '',
            placeOfSupply: '',
            poNumber: '',
            transportMode: '',
            paymentTerms: ''
        },
        validate: (values: any) => {
            const errors: {
                invoiceDate?: string;
                placeOfSupply?: string;
                poNumber?: string;
            } = {};
            if (!values.invoiceDate) {
                errors.invoiceDate = 'Required';
            }
            if (!companyDetailsId) {
                errors.placeOfSupply = 'Required';
            }
            if (!values.poNumber) {
                errors.poNumber = 'Required';
            }
            return errors;
        },
        //validateOnChange: false,
        onSubmit: () => { invoiceFromId?.value === 1 ? updateInvoiceSubmit() : addSubInvoiceSubmit() },
    });

    function onActivate(data: any, type: number) {
        const bop = companyDetailsData.find((b: any) => b.companyDetailsId == data.billOfParty);
        const bopValue = bop ? { value: bop.companyDetailsId, label: bop.companyName } : '';

        if (type == 1) {
            setInvoiceFromId({ value: 1, label: 'ACV PRODUCTS PRIVATE LIMITED' });
            setCompanyDetailsId(data.companyDetailsId > 0 ? { value: data.companyDetailsId, label: `${data.companyName} - ${data.cityName}` } : '');
            setPlaceOfSupplyStateId(data.stateId)
            setBillOfParty(bopValue);
            invoiceForm.setValues({
                invoiceDate: data.invoiceDate,
                billOfParty: data.billOfParty,
                placeOfSupply: data.companyDetailsId,
                poNumber: data.poNumber,
                transportMode: data.transportMode,
                paymentTerms: data.paymentTerms
            });
        } else {
            setInvoiceFromId({ value: 2, label: 'AVR TERRY TEX' });
            setCompanyDetailsId(data.companyDetailsId > 0 ? { value: data.companyDetailsId, label: `${data.companyName} - ${data.cityName}` } : '');
            setPlaceOfSupplyStateId(data.stateId)
            setBillOfParty(bopValue);
            invoiceForm.setValues({
                invoiceDate: getCurrentDateAndTime('date'),
                billOfParty: data.billOfParty || '',
                placeOfSupply: data.companyDetailsId || '',
                poNumber: data.poNumber || '',
                transportMode: data.transportMode || '',
                paymentTerms: data.paymentTerms || '',
            });
        }

        setInvoiceDetailsData(data);
        setIsOpenModal(true);

        const flattenedDetails: any[] = [];
        if (data?.productDetails && data.productDetails.length > 0) {
            data.productDetails.forEach((product: any) => {
                const { amountDetails, ...productInfo } = product;
                if (amountDetails && amountDetails.length > 0) {
                    const filteredAmountDetails = type === 2 ? amountDetails.filter((amount: any) => !amount.isSubInvoice) : amountDetails;
                    if (filteredAmountDetails && filteredAmountDetails.length > 0) {
                        filteredAmountDetails.forEach((amount: any) => {
                            flattenedDetails.push({
                                ...productInfo,
                                ...amount,
                                isAdd: hsnCodeData?.length > 0 ? false : true,
                                isSelected: type == 2 ? false : true,
                                finalAmount: type == 2 ? '' : (amount.invoiceAmount || 0),
                                cgstRate: amount.cgstRate || '2.5',
                                cgstAmount: amount.cgstAmount,
                                sgstRate: amount.sgstRate || '2.5',
                                sgstAmount: amount.sgstAmount,
                                discountAmount: amount.discountAmount,
                                discountPercentage: amount.discountPercentage,
                                igstAmount: amount.igstAmount,
                                igstRate: amount.igstRate || '2.5',
                                productRate: type == 2 ? '' : amount.productRate,
                                totalAmount: type == 2 ? '' : amount.totalAmount,
                            });
                        });
                    }
                } else {
                    // product with no details - add default row
                    flattenedDetails.push({
                        ...productInfo,
                        invoiceDetailsId: 0,
                        hsnCode: '',
                        noOfBags: '',
                        quantity: '',
                        productRate: '',
                        totalAmount: '0.00',
                        discountPercentage: '0',
                        discountAmount: '0.00',
                        cgstRate: '2.5',
                        cgstAmount: '0.00',
                        sgstRate: '2.5',
                        sgstAmount: '0.00',
                        igstRate: '2.5',
                        igstAmount: '0.00',
                        invoiceAmount: '0.00',
                        finalAmount: '0.00',
                        isAdd: hsnCodeData?.length > 0 ? false : true,
                        isSelected: type === 2 ? false : true,
                    });
                }
            });
        }

        const totalNoOfBags = flattenedDetails.reduce((s: any, r: any) => s + Number(r.noOfBags || 0), 0);
        const totalQuantity = flattenedDetails.reduce((s: any, r: any) => s + Number(r.quantity || 0), 0);
        const totalProductAmount = flattenedDetails.reduce((s: any, r: any) => s + Number(r.totalAmount || 0), 0);
        const finalProductAmount = flattenedDetails.reduce((s: any, r: any) => s + Number(r.finalAmount || 0), 0);

        setNoOfBags(totalNoOfBags);
        setQuantity(totalQuantity);
        setTotalAmount(totalProductAmount);
        setFinalAmount(finalProductAmount);
        setInputList(flattenedDetails);
        setDispatchDetails(flattenedDetails);
    }

    const [placeOfSupplyStateId, setPlaceOfSupplyStateId] = useState<any>('')
    const [billOfParty, setBillOfParty] = useState<any>('')

    function selectPlaceOfSupply(e: any) {
        if (e?.value != undefined) {
            setCompanyDetailsId(e)
            const companyData = companyDetailsData?.filter((item: any) => item.companyDetailsId == e?.value)
            const stateId = companyData[0]?.stateId;
            setPlaceOfSupplyStateId(stateId)

            const list = inputList.map((item: any) => {
                return calculateRow(item, item.hsnCode, item.noOfBags, item.quantity, item.productRate, item.discountPercentage, item.cgstRate, item.sgstRate, item.igstRate, item.isAdd, stateId);
            });
            setInputList(list);
            setDispatchDetails(list);
            calculateTotals(list);
        } else {
            setCompanyDetailsId('')
            setPlaceOfSupplyStateId('')
        }
    }


    const [dispatchDetails, setDispatchDetails] = useState<any>([])
    const [inputList, setInputList] = useState<any>([])

    function addInputList(data: any, index: any) {
        const list = [...inputList];
        const newItem = {
            ...data,
            invoiceDetailsId: 0,
            hsnCode: '',
            noOfBags: '',
            quantity: '',
            productRate: '',
            discountPercentage: '',
            discountAmount: '0.00',
            cgstRate: '2.5',
            cgstAmount: '0.00',
            sgstRate: '2.5',
            sgstAmount: '0.00',
            igstRate: '2.5',
            igstAmount: '0.00',
            totalAmount: '0.00',
            finalAmount: '0.00',
            invoiceAmount: '0.00',
            isNew: true // Added to identify newly added rows for UI
        };


        list.splice(index + 1, 0, newItem);
        setInputList(list);
        setDispatchDetails(list);
    }

    function removeInputList(index: any) {
        const list = [...inputList];
        list.splice(index, 1);

        calculateTotals(list);

        setInputList(list);
        setDispatchDetails(list);
    }

    const [noOfBags, setNoOfBags] = useState<any>('');
    const [quantity, setQuantity] = useState<any>('');
    const [totalAmount, setTotalAmount] = useState<any>('');
    const [finalAmount, setFinalAmount] = useState<any>('');

    function calculateTotals(list: any[]) {
        const itemsToSum = invoiceFromId?.value === 2 ? list.filter((i: any) => i.isSelected) : list;

        const totalNoOfBags = itemsToSum.reduce((s: any, r: any) => s + Number(r.noOfBags || 0), 0);
        const totalQuantity = itemsToSum.reduce((s: any, r: any) => s + Number(r.quantity || 0), 0);
        const totalProductAmount = itemsToSum.reduce((s: any, r: any) => s + Number(r.totalAmount || 0), 0);
        const finalProductAmount = itemsToSum.reduce((s: any, r: any) => s + Number(r.finalAmount || 0), 0);

        setNoOfBags(totalNoOfBags);
        setQuantity(totalQuantity);
        setTotalAmount(Number(totalProductAmount.toFixed(2)));
        setFinalAmount(Number(finalProductAmount.toFixed(2)));
    }

    function toggleSelection(index: any) {
        const list = [...inputList];
        list[index].isSelected = !list[index].isSelected;

        calculateTotals(list);

        setInputList(list);
        setDispatchDetails(list);
    }

    function calculateRow(data: any, hsnCode: any, noOfBags: any, quantity: any, productRate: any, discountPercentage: any, cgstRate: any, sgstRate: any, igstRate: any, isAdd: any, stateId: any) {
        const _noOfBags = Number(noOfBags || 0);
        const _quantity = Number(quantity || 0);
        const _rate = Number(productRate || 0);
        const _discountPercentage = Number(discountPercentage || 0);
        const _cgstRate = Number(cgstRate || 0);
        const _sgstRate = Number(sgstRate || 0);
        const _igstRate = Number(igstRate || 0);

        const row = { ...data };
        row["isAdd"] = isAdd;
        row["hsnCode"] = hsnCode || "";
        row["noOfBags"] = _noOfBags;
        row["productRate"] = _rate > 0 ? _rate : '';
        row["quantity"] = _quantity;

        const grossAmount = _quantity * _rate;
        row["totalAmount"] = Number(grossAmount).toFixed(2);

        // Handle Discount
        let taxableAmount = grossAmount;
        if (stateId != 31) {
            row["discountPercentage"] = _discountPercentage > 0 ? _discountPercentage : '';
            const discountAmt = (grossAmount * _discountPercentage) / 100;
            row["discountAmount"] = Number(discountAmt).toFixed(2);
            taxableAmount = grossAmount - discountAmt;
        } else {
            row["discountPercentage"] = "0";
            row["discountAmount"] = "0.00";
        }

        let totalTax = 0;
        if (stateId == 31) {
            const finalCgstRate = _cgstRate > 0 ? _cgstRate : 2.5;
            const finalSgstRate = _sgstRate > 0 ? _sgstRate : 2.5;

            row["cgstRate"] = finalCgstRate;
            const cgstAmt = (taxableAmount * finalCgstRate) / 100;
            row["cgstAmount"] = Number(cgstAmt).toFixed(2);
            row["sgstRate"] = finalSgstRate;
            const sgstAmt = (taxableAmount * finalSgstRate) / 100;
            row["sgstAmount"] = Number(sgstAmt).toFixed(2);
            totalTax = cgstAmt + sgstAmt;
            row["igstRate"] = "0";
            row["igstAmount"] = "0.00";
        } else {
            const finalIgstRate = _igstRate > 0 ? _igstRate : 5;
            row["igstRate"] = finalIgstRate;
            const igstAmt = (taxableAmount * finalIgstRate) / 100;
            row["igstAmount"] = Number(igstAmt).toFixed(2);
            totalTax = igstAmt;
            row["cgstRate"] = "0";
            row["cgstAmount"] = "0.00";
            row["sgstRate"] = "0";
            row["sgstAmount"] = "0.00";
        }

        const finalAmt = taxableAmount + totalTax;
        row["finalAmount"] = Number(finalAmt).toFixed(2);
        row["invoiceAmount"] = Number(finalAmt).toFixed(2);

        return row;
    }

    function handleInputChange(data: any, hsnCode: any, noOfBags: any, quantity: any, productRate: any, discountPercentage: any, cgstRate: any, sgstRate: any, igstRate: any, isAdd: any, index: any) {
        const list = [...inputList];
        list[index] = calculateRow(data, hsnCode, noOfBags, quantity, productRate, discountPercentage, cgstRate, sgstRate, igstRate, isAdd, placeOfSupplyStateId);

        calculateTotals(list);
        setInputList(list);
        setDispatchDetails(list);
    }

    function closeAndReset() {
        invoiceForm.resetForm()
        setIsOpenModal(false)
        setCompanyDetailsId('')
        setInvoiceFromId('')
        setInputList([])
        setDispatchDetails([])
    }

    function setInvoiceDetails() {

        return ({
            licenseKey: getLicenseKey,
            poNumber: invoiceForm.values.poNumber,
            supplyCompanyId: companyDetailsId?.value,
            transportMode: invoiceForm.values.transportMode,
            paymentTerms: invoiceForm.values.paymentTerms,
            userAccountId: userAccountId,
            invoiceDetails: dispatchDetails.map((item: any) => ({
                invoiceDetailsId: item.invoiceDetailsId,
                hsnCode: item.hsnCode,
                noOfBags: item.noOfBags,
                netWeight: item.quantity,
                bagRate: item.productRate,
                totalAmount: item.totalAmount,
                cgstPercentage: item.cgstRate,
                cgstAmount: item.cgstAmount,
                sgstPercentage: item.sgstRate,
                sgstAmount: item.sgstAmount,
                discountPercentage: item.discountPercentage,
                discountAmount: item.discountAmount,
                igstRate: item.igstRate,
                igstAmount: item.igstAmount,
                finalAmount: item.finalAmount,
                isSubInvoice: item.isSubInvoice || 0
            }))
        })
    }

    function updateInvoiceSubmit() {
        showLoader(true)
        let invoicePostData = setInvoiceDetails()
        if (dispatchDetails.length > 0) {
            if (invoiceForm.isValid) {
                updateInvoiceDetails(invoicePostData,
                    (response) => {
                        const data = response.data;
                        if (data.success == true) {
                            showLoader(false)
                            setAlertStatus({ message: data.message, type: "success" });
                            setIsOpen(true);
                            closeAndReset()
                            getInvoice()
                        }
                        else if (data.success == false) {
                            showLoader(false)
                            setAlertStatus({ message: data.message, type: "error" });
                            setIsOpen(true);
                        }
                        else {
                            let errorCode = response.data.error[0].error_code;
                            let errorDescription = response.data.error[0].error_description;
                            showLoader(false)
                            setAlertStatus({ message: errorDescription, type: "error" });
                            setIsOpen(true);
                        }
                    }
                    , (error) => {
                        showLoader(false)
                        setAlertStatus({ message: error, type: "error" });
                        setIsOpen(true);
                    }
                )
            } else if (invoiceForm.isValid == false) {
                toasts("Please fill all details", "Error");
            }
        }
        else {
            toasts("Please Enter Dispatch Details", "Error");
        }
    }

    function setSubInvoiceDetails() {
        const selectedItems = dispatchDetails.filter((item: any) => item.isSelected);
        return ({
            licenseKey: getLicenseKey,
            userAccountId: userAccountId,
            invoiceNo: invoiceDetailsData?.invoiceNo,
            invoiceUniqueNo: invoiceDetailsData?.invoiceId,
            invoiceDate: invoiceForm.values.invoiceDate,
            poNumber: invoiceForm.values.poNumber,
            billOfParty: billOfParty?.value,
            supplyCompanyId: companyDetailsId?.value,
            transportMode: invoiceForm.values.transportMode,
            subInvoiceDetails: selectedItems.map((item: any) => ({
                subInvoiceDetailsId: 0,
                invoiceDetailsId: item.invoiceDetailsId,
                hsnCodeId: hsnCodeData.find((h: any) => h.hsnCode === item.hsnCode)?.hsnCodeId || 0,
                noOfBags: item.noOfBags,
                netWeight: item.quantity,
                bagRate: item.productRate,
                totalAmount: item.totalAmount,
                cgstPercentage: item.cgstRate,
                cgstAmount: item.cgstAmount,
                sgstPercentage: item.sgstRate,
                sgstAmount: item.sgstAmount,
                igstPercentage: item.igstRate || 0,
                igstAmount: item.igstAmount || 0,
                discountPercentage: item.discountPercentage || 0,
                discountAmount: item.discountAmount || 0,
                finalAmount: item.finalAmount,
                paymentTerms: invoiceForm.values.paymentTerms,
                pdfPath: ""
            }))
        })
    }

    function addSubInvoiceSubmit() {
        showLoader(true)
        let invoicePostData = setSubInvoiceDetails()
        if (dispatchDetails.length > 0) {
            if (invoiceForm.isValid) {
                updateSubInvoiceDetails(invoicePostData,
                    (response) => {
                        const data = response.data;
                        if (data.success == true) {
                            showLoader(false)
                            setAlertStatus({ message: data.message, type: "success" });
                            setIsOpen(true);
                            closeAndReset()
                            getInvoice()
                        }
                        else if (data.success == false) {
                            showLoader(false)
                            setAlertStatus({ message: data.message, type: "error" });
                            setIsOpen(true);
                        }
                        else {
                            let errorCode = response.data.error[0].error_code;
                            let errorDescription = response.data.error[0].error_description;
                            showLoader(false)
                            setAlertStatus({ message: errorDescription, type: "error" });
                            setIsOpen(true);
                        }
                    }
                    , (error) => {
                        showLoader(false)
                        setAlertStatus({ message: error, type: "error" });
                        setIsOpen(true);
                    }
                )
            } else if (invoiceForm.isValid == false) {
                toasts("Please fill all details", "Error");
            }
        }
        else {
            toasts("Please Enter Dispatch Details", "Error");
        }
    }

    return (
        <PageWrapper title={`Invoice List`}>
            <Page>
                <Card stretch data-tour='list'>
                    <CardHeader borderSize={1}>
                        <CardLabel icon='List' iconColor='info' className="col-lg-7">
                            <CardTitle tag='div' className='h5'>Invoice List</CardTitle>
                        </CardLabel>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                        <ButtonGroup className="col-lg-3 d-print-none" color='primary'>
                            <Icon className="mt-1" icon='Search' size='2x' color='primary' />
                            <Input id='searchInput' type='search' placeholder='Search...' onChange={columnVisibileForm.handleChange} value={columnVisibileForm.values.searchInput} />
                        </ButtonGroup>
                    </CardHeader>
                    <CardBody>
                        {!dataStatus ?
                            <TableLoader /> :
                            <div className="table-responsive">
                                <table className='table table-modern table-hover'>
                                    <thead className='table-primary'>
                                        <tr>
                                            <th scope='col' onClick={() => requestSort('sno')} className='cursor-pointer py-3 border-bottom-0 bg-light rounded-start'>
                                                <span className='small text-uppercase fw-bold'>S.No</span>
                                                <Icon size='lg' className={getClassNamesFor('sno')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('companyName')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Company Name</span>
                                                <Icon size='lg' className={getClassNamesFor('companyName')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('invoiceNo')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Invoice No</span>
                                                <Icon size='lg' className={getClassNamesFor('invoiceNo')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('invoiceDateForView')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Invoice Date</span>
                                                <Icon size='lg' className={getClassNamesFor('invoiceDateForView')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('poNumber')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>PO Number</span>
                                                <Icon size='lg' className={getClassNamesFor('poNumber')} icon='FilterList' />
                                            </th>
                                            <th scope='col' onClick={() => requestSort('truckNo')} className='cursor-pointer py-3 border-bottom-0 bg-light'>
                                                <span className='small text-uppercase fw-bold'>Vehicle No</span>
                                                <Icon size='lg' className={getClassNamesFor('truckNo')} icon='FilterList' />
                                            </th>
                                            <th className='py-3 border-bottom-0 bg-light rounded-end'>
                                                <span className='small text-uppercase fw-bold'>Action</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    {filteredData != "" ? <>
                                        {filteredData.map((item: any) => (
                                            <tbody key={item.invoiceId} className='border-top-0'>
                                                <tr className='shadow-hover-sm transition-base'>
                                                    <td className='py-3 fw-bold text-muted'>{item.sno}</td>
                                                    <td className='py-3 fw-semibold'>{item.companyName}</td>
                                                    <td className='py-3 fw-semibold text-dark'>{item.invoiceNo}</td>
                                                    <td className='py-3 text-muted small'>{item.invoiceDateForView}</td>
                                                    <td className={`py-3 ${item.poNumber == null ? 'text-center' : ''}`}>
                                                        {item.poNumber != null ? item.poNumber : '-'}
                                                    </td>
                                                    <td className='py-3 fw-semibold text-primary'>{item.truckNo}</td>
                                                    <td className="py-3 d-print-none">
                                                        <Button
                                                            color='primary'
                                                            isLight
                                                            icon='Edit'
                                                            className='rounded-pill shadow-sm'
                                                            aria-label='Edit'
                                                            onClick={() => onActivate(item, 1)}
                                                        />
                                                        {item.pdfPath != null ? (
                                                            <>
                                                                <Button
                                                                    className="ms-2 rounded-pill shadow-sm"
                                                                    color='success'
                                                                    isLight
                                                                    icon='Download'
                                                                    aria-label='Download'
                                                                    onClick={() => onPrint(item)}
                                                                />
                                                                {item.supplyCompanyId == 2 && item.isSubInvoiceComplete == 0 ? (
                                                                    <Button
                                                                        className="ms-2 rounded-pill shadow-sm"
                                                                        color='info'
                                                                        isLight
                                                                        icon='Receipt'
                                                                        aria-label='Download'
                                                                        onClick={() => onActivate(item, 2)}
                                                                    >
                                                                        AVR Invoice
                                                                    </Button>
                                                                ) : null}
                                                            </>
                                                        ) : null}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ))}
                                    </> : <NoDataMsg columnsCount={10} msg={noDataMsg} />}
                                </table>
                            </div>
                        }
                    </CardBody>
                    <PaginationButtons className="d-print-none" data={items} label='items' setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
                </Card>
            </Page>

            <Modal
                setIsOpen={closeAndReset}
                isOpen={isOpenModal}
                titleId='edit'
                isStaticBackdrop
                fullScreen
                size='xl'>
                <ModalHeader setIsOpen={closeAndReset}>
                    <ModalTitle id='examplemailcontent'>
                        <div className="h4">Add Invoice</div>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className='row g-4'>
                        <div className="row g-3">
                            <div className={`${invoiceFromId?.value === 1 ? 'col-lg-4' : 'col-lg-3'} `}>
                                <FormGroup id='invoiceFrom' label='Invoice From' isFloating>
                                    <SearchableSelect
                                        disabled
                                        isFloating
                                        ariaLabel='invoiceFrom'
                                        onChange={(e: any) => setInvoiceFromId(e)}
                                        value={invoiceFromId}
                                        list={invoiceFromData.map((data: any) => ({
                                            value: data.companyDetailsId,
                                            label: data.companyName,
                                        }))}
                                        required
                                    />
                                </FormGroup>
                            </div>
                            <div className={`${invoiceFromId?.value === 1 ? 'col-lg-4' : 'col-lg-3'} `}>
                                <FormGroup id='companyName' label='Company Name' isFloating>
                                    <Input value={invoiceDetailsData?.companyName + ' - ' + invoiceDetailsData?.cityName} disabled />
                                </FormGroup>
                            </div>
                            {invoiceFromId?.value === 2 ?
                                <div className={`col-lg-3`}>
                                    <FormGroup id='billOfParty' label='Bill Of Party' isFloating>
                                        <SearchableSelect
                                            isFloating
                                            ariaLabel='billOfParty'
                                            onChange={(e: any) => setBillOfParty(e)}
                                            value={billOfParty}
                                            onBlur={invoiceForm.handleBlur}
                                            isValid={invoiceForm.isValid}
                                            isTouched={invoiceForm.touched.billOfParty}
                                            invalidFeedback={invoiceForm.errors.billOfParty}
                                            list={companyDetailsData.map((data: any) => ({
                                                value: data.companyDetailsId,
                                                label: data.companyNameAndCityName,
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                </div> : null
                            }
                            <div className={`${invoiceFromId?.value === 1 ? 'col-lg-4' : 'col-lg-3'} `}>
                                <FormGroup id='placeOfSupply' label='Place of Supply' isFloating>
                                    <SearchableSelect
                                        isFloating
                                        ariaLabel='placeOfSupply'
                                        onChange={selectPlaceOfSupply}
                                        value={companyDetailsId}
                                        onBlur={invoiceForm.handleBlur}
                                        isValid={invoiceForm.isValid}
                                        isTouched={invoiceForm.touched.placeOfSupply}
                                        invalidFeedback={invoiceForm.errors.placeOfSupply}
                                        list={companyDetailsData.map((data: any) => ({
                                            value: data.companyDetailsId,
                                            label: data.companyNameAndCityName,
                                        }))}
                                        required
                                    />
                                </FormGroup>
                            </div>
                            <div className='col-lg-2'>
                                <FormGroup id='invoiceNo' label='Invoice No' isFloating>
                                    <Input value={invoiceDetailsData?.invoiceNo || ''} disabled />
                                </FormGroup>
                            </div>
                            <div className='col-lg-2'>
                                <FormGroup id='invoiceDate' label='Invoice Date' isFloating>
                                    <Input
                                        type='date'
                                        onChange={invoiceForm.handleChange}
                                        onBlur={invoiceForm.handleBlur}
                                        isValid={invoiceForm.isValid}
                                        isTouched={invoiceForm.touched.invoiceDate}
                                        invalidFeedback={invoiceForm.errors.invoiceDate}
                                        value={invoiceForm.values.invoiceDate}
                                    />
                                </FormGroup>
                            </div>
                            <div className='col-lg-2'>
                                <FormGroup id='truckNo' label='Truck No' isFloating>
                                    <Input value={invoiceDetailsData?.truckNo || ''} disabled />
                                </FormGroup>
                            </div>
                            <div className="col-lg-2">
                                <FormGroup id='poNumber' label='PO Number' isFloating>
                                    <Input
                                        value={invoiceForm.values.poNumber}
                                        onChange={invoiceForm.handleChange}
                                        onBlur={invoiceForm.handleBlur}
                                        isValid={invoiceForm.isValid}
                                        isTouched={invoiceForm.touched.poNumber}
                                        invalidFeedback={invoiceForm.errors.poNumber}
                                        placeholder="Enter PO Number" />
                                </FormGroup>
                            </div>
                            <div className="col-lg-2">
                                <FormGroup id='transportMode' label='Transport Mode' isFloating>
                                    <Input
                                        value={invoiceForm.values.transportMode}
                                        onChange={invoiceForm.handleChange}
                                        onBlur={invoiceForm.handleBlur}
                                        isValid={invoiceForm.isValid}
                                        isTouched={invoiceForm.touched.transportMode}
                                        invalidFeedback={invoiceForm.errors.transportMode}
                                        placeholder="Enter Transport Mode" />
                                </FormGroup>
                            </div>
                            <div className="col-lg-2">
                                <FormGroup id='paymentTerms' label='Payment Terms' isFloating>
                                    <Input
                                        value={invoiceForm.values.paymentTerms}
                                        onChange={invoiceForm.handleChange}
                                        onBlur={invoiceForm.handleBlur}
                                        isValid={invoiceForm.isValid}
                                        isTouched={invoiceForm.touched.paymentTerms}
                                        invalidFeedback={invoiceForm.errors.paymentTerms}
                                        placeholder="Enter Payment Terms" />
                                </FormGroup>
                            </div>
                        </div>
                        <div className="row g-2">
                            <div className="col-lg-12">
                                {/* <div className="table-responsive"> */}
                                <table className="table table-bordered table-modern align-middle">
                                    <thead className="bg-light">
                                        <tr>
                                            {invoiceFromId?.value === 2 && <th style={{ width: '30px' }}>Select</th>}
                                            <th style={{ minWidth: '140px' }}>Product / Lot</th>
                                            <th style={{ minWidth: '180px' }}>HSN Code</th>
                                            <th style={{ width: '70px' }}>Bags</th>
                                            <th style={{ width: '100px' }}>Qty</th>
                                            <th style={{ width: '100px' }}>Rate</th>
                                            <th style={{ width: '100px' }}>Amount</th>
                                            {placeOfSupplyStateId != 31 && (
                                                <>
                                                    <th style={{ width: '80px' }}>Disc %</th>
                                                    <th style={{ width: '100px' }}>Disc ₹</th>
                                                    <th style={{ width: '80px' }}>IGST %</th>
                                                    <th style={{ width: '100px' }}>IGST ₹</th>
                                                </>
                                            )}
                                            {placeOfSupplyStateId == 31 && (
                                                <>
                                                    <th style={{ width: '80px' }}>CGST %</th>
                                                    <th style={{ width: '100px' }}>CGST ₹</th>
                                                    <th style={{ width: '80px' }}>SGST %</th>
                                                    <th style={{ width: '100px' }}>SGST ₹</th>
                                                </>
                                            )}
                                            <th style={{ width: '100px' }}>Total Amount</th>
                                            {invoiceFromId?.value === 1 &&
                                                <th style={{ width: '80px' }}>Action</th>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {inputList.map((x: any, index: any) => {
                                            const isFirstRow = index === 0 || inputList[index - 1].dispatchProductDetailsId !== x.dispatchProductDetailsId;
                                            const isLastRow = index === inputList.length - 1 || inputList[index + 1].dispatchProductDetailsId !== x.dispatchProductDetailsId;
                                            let rowSpan = 1;
                                            if (isFirstRow) {
                                                for (let i = index + 1; i < inputList.length; i++) {
                                                    if (inputList[i].dispatchProductDetailsId === x.dispatchProductDetailsId) {
                                                        rowSpan++;
                                                    } else {
                                                        break;
                                                    }
                                                }
                                            }

                                            return (
                                                <tr key={index}>
                                                    {invoiceFromId?.value === 2 && (
                                                        <td>
                                                            <div className="form-check d-flex justify-content-center">
                                                                <input
                                                                    className="form-check-input border border-primary"
                                                                    type="checkbox"
                                                                    checked={x.isSelected || false}
                                                                    onChange={() => toggleSelection(index)}
                                                                />
                                                            </div>
                                                        </td>
                                                    )}
                                                    {isFirstRow && (
                                                        <td rowSpan={rowSpan}>
                                                            <div className="fw-bold text-muted small">{x.countNo}</div>
                                                            <div className="small">Lot: <span className="text-primary fw-bold">{x.lotNo}</span></div>
                                                        </td>
                                                    )}
                                                    <td>
                                                        <InputGroup size='sm'>
                                                            {x.isAdd === false ? (
                                                                <SearchableSelect
                                                                    disabled={invoiceFromId?.value === 2 && !x.isSelected}
                                                                    ariaLabel='hsnCode'
                                                                    onChange={(e: any) => handleInputChange(x, e?.value || '', x.noOfBags, x.quantity, x.productRate, x.discountPercentage, x.cgstRate, x.sgstRate, x.igstRate, x.isAdd, index)}
                                                                    value={x.hsnCode ? { value: x.hsnCode, label: x.hsnCode } : null}
                                                                    list={hsnCodeData.map((data: any) => ({
                                                                        value: data.hsnCode,
                                                                        label: data.hsnCode,
                                                                    }))}
                                                                />
                                                            ) : (
                                                                <Input
                                                                    size='sm'
                                                                    disabled={invoiceFromId?.value === 2 && !x.isSelected}
                                                                    onChange={(e: any) => handleInputChange(x, e.target.value, x.noOfBags, x.quantity, x.productRate, x.discountPercentage, x.cgstRate, x.sgstRate, x.igstRate, x.isAdd, index)}
                                                                    value={x.hsnCode || ''}
                                                                    placeholder="HSN"
                                                                />
                                                            )}
                                                            <Button
                                                                isOutline
                                                                icon='Add'
                                                                color='primary'
                                                                isDisable={invoiceFromId?.value === 2 && !x.isSelected}
                                                                onClick={() => handleInputChange(x, x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.discountPercentage, x.cgstRate, x.sgstRate, x.igstRate, !x.isAdd, index)}
                                                            />
                                                        </InputGroup>
                                                    </td>
                                                    <td>
                                                        <Input
                                                            size='sm'
                                                            value={x.noOfBags || ''}
                                                            onChange={(e: any) => handleInputChange(x, x.hsnCode, e.target.value, x.quantity, x.productRate, x.discountPercentage, x.cgstRate, x.sgstRate, x.igstRate, x.isAdd, index)}
                                                            disabled={invoiceFromId?.value === 2 ? !x.isSelected : (!x.isNew && x.invoiceDetailsId !== 0)}
                                                            onKeyDown={(e: any) => onlyAllowNumber(e)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Input
                                                            size='sm'
                                                            value={x.quantity || ''}
                                                            onChange={(e: any) => handleInputChange(x, x.hsnCode, x.noOfBags, e.target.value, x.productRate, x.discountPercentage, x.cgstRate, x.sgstRate, x.igstRate, x.isAdd, index)}
                                                            disabled={invoiceFromId?.value === 2 ? !x.isSelected : (!x.isNew && x.invoiceDetailsId !== 0)}
                                                            onKeyDown={(e: any) => onlyAllowNumber(e)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Input
                                                            size='sm'
                                                            onChange={(e: any) => handleInputChange(x, x.hsnCode, x.noOfBags, x.quantity, e.target.value, x.discountPercentage, x.cgstRate, x.sgstRate, x.igstRate, x.isAdd, index)}
                                                            value={x.productRate || ''}
                                                            disabled={invoiceFromId?.value === 2 && !x.isSelected}
                                                            onKeyDown={(e: any) => onlyAllowNumber(e)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Input
                                                            size='sm'
                                                            value={x.totalAmount || ''}
                                                            disabled
                                                            className="bg-light"
                                                        />
                                                    </td>
                                                    {placeOfSupplyStateId != 31 && (
                                                        <>
                                                            <td>
                                                                <Input
                                                                    size='sm'
                                                                    onChange={(e: any) => handleInputChange(x, x.hsnCode, x.noOfBags, x.quantity, x.productRate, e.target.value, x.cgstRate, x.sgstRate, x.igstRate, x.isAdd, index)}
                                                                    value={x.discountPercentage || ''}
                                                                    disabled={invoiceFromId?.value === 2 && !x.isSelected}
                                                                    onKeyDown={(e: any) => onlyAllowNumber(e)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    size='sm'
                                                                    value={x.discountAmount || ''}
                                                                    disabled
                                                                />
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    size='sm'
                                                                    onChange={(e: any) => handleInputChange(x, x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.discountPercentage, x.cgstRate, x.sgstRate, e.target.value, x.isAdd, index)}
                                                                    value={x.igstRate || ''}
                                                                    disabled={invoiceFromId?.value === 2 && !x.isSelected}
                                                                    onKeyDown={(e: any) => onlyAllowNumber(e)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    size='sm'
                                                                    value={x.igstAmount || ''}
                                                                    disabled
                                                                />
                                                            </td>
                                                        </>
                                                    )}
                                                    {placeOfSupplyStateId == 31 && (
                                                        <>
                                                            <td>
                                                                <Input
                                                                    size='sm'
                                                                    onChange={(e: any) => handleInputChange(x, x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.discountPercentage, e.target.value, x.sgstRate, x.igstRate, x.isAdd, index)}
                                                                    value={x.cgstRate || ''}
                                                                    onKeyDown={(e: any) => onlyAllowNumber(e)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    size='sm'
                                                                    value={x.cgstAmount || ''}
                                                                    disabled
                                                                />
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    size='sm'
                                                                    onChange={(e: any) => handleInputChange(x, x.hsnCode, x.noOfBags, x.quantity, x.productRate, x.discountPercentage, x.cgstRate, e.target.value, x.igstRate, x.isAdd, index)}
                                                                    value={x.sgstRate || ''}
                                                                    onKeyDown={(e: any) => onlyAllowNumber(e)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    size='sm'
                                                                    value={x.sgstAmount || ''}
                                                                    disabled
                                                                />
                                                            </td>
                                                        </>
                                                    )}
                                                    <td>
                                                        <Input
                                                            size='sm'
                                                            value={x.invoiceAmount || ''}
                                                            disabled
                                                            className="bg-light fw-bold text-primary"
                                                        />
                                                    </td>
                                                    {invoiceFromId?.value === 1 &&
                                                        <td>
                                                            <div className="d-flex justify-content-center">
                                                                {x.isNew && !isFirstRow ? (
                                                                    <Button color='danger' isLight icon='Delete' className="me-2" aria-label='Delete' onClick={() => removeInputList(index)}></Button>
                                                                ) : null}
                                                                {isLastRow && (
                                                                    <Button color='primary' isLight icon='Add' aria-label='Add' onClick={() => addInputList(x, index)}></Button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    }
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            {/* </div> */}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color='info'
                        isOutline
                        className='border-0'
                        onClick={closeAndReset}>
                        Close
                    </Button>
                    <Button color='info' type="submit" icon="Save" onClick={invoiceForm.handleSubmit}>
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>

            <AlertService setIsOpen={setIsOpen} isOpen={isOpen} alertStatus={alertStatus} />

        </PageWrapper >
    )
}

export default InvoiceList